import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class HomeService {

  constructor(private http: HttpClient) { }

  getEndpointOnboardCount() {
    return this.http.get<any>(`${environment.apiUrl}utility/onboard/api/count`);
  }

  geWebFlowOnboardCount() {
    return this.http.get<any>(`${environment.apiUrl}utility/onboard/web/count`);
  }

  getPerfTestCount() {
    return this.http.get<any>(`${environment.apiUrl}utility/perf/execution/count`);
  }
}
